
// announcement bar header
function updateAnnouncementBarHeight() {
  const announcementBar = document.querySelector('.announcement-bar-section');

  if (announcementBar) {
    const height = announcementBar.offsetHeight;
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      `${height}px`
    );
  } else {
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      '0px'
    );
  }
}

document.addEventListener('DOMContentLoaded', updateAnnouncementBarHeight);
window.addEventListener('resize', updateAnnouncementBarHeight);